$(document).ready(function(){

	// -- Sliders --
  var sliderGallery = $('.slider--gallery');
  var sliderRegions = $('.slider--regions');
  var sliderHighlightedEvents = $('.slider--highlightedEvents');
  var sliderHighlightedNews = $('.slider--highlightedNews');


  // -- Settings --
  var sliderGallerySettings = {
		arrows: true,
		dots: true,
		infinite: false,
  };

  var sliderMobileSettings = {
		arrows: true,
		dots: true,
		infinite: false,
		mobileFirst: true,
		adaptiveHeight: true,
	  responsive: [
	    {
	      breakpoint: 767,
	      settings: "unslick"
	    }
	  ]
  };

  // -- Init sliders --
  sliderGallery.slick(sliderGallerySettings);
  sliderRegions.slick(sliderMobileSettings);
  sliderHighlightedEvents.slick(sliderMobileSettings);
  sliderHighlightedNews.slick(sliderMobileSettings);

});